import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

import LayoutActions from './LayoutActions';

const WidgetAuthActions = {

    startSession () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.WIDGET_AUTH_SESSION_STARTED
        });
        LayoutActions.setEmbedded(true);
    }

};

export default WidgetAuthActions;
